module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helena Hunt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Helena Hunt")]), _vm._v(" is an editor living in Chicago.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jmiEft/tc-custom/9781572848184.jpg?1700795666361",
      "alt": "This image is the cover for the book Ruth Bader Ginsburg, In Their Own Words"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ruth Bader Ginsburg, In Their Own Words\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Like so many cultural icons, Ginsberg has doled out some seriously memorable quotes, thoughts, and observations . . . a quick dip of inspiration.” —"), _c('i', [_vm._v("Bustle")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" As one of only nine women in a class of 500 at Harvard Law School when she enrolled in 1956 and one of only four female Supreme Court justices in the history of the United States, Ruth Bader Ginsburg was frequently viewed as a feminist trailblazer and an icon for civil rights."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Ginsburg had always been known as a prolific writer and speaker. Now, "), _c('i', [_vm._v("Ruth Bader Ginsburg: In Her Own Words")]), _vm._v(" offers a unique look into the mind of one of the world’s most influential women by collecting 300 of Ginsburg’s most insightful quotes. Meticulously curated from interviews, speeches, court opinions, dissents, and other sources, "), _c('i', [_vm._v("Ruth Bader Ginsburg: In Her Own Words")]), _vm._v(" creates a comprehensive picture of Ruth Bader Ginsburg, her wisdom, and her legacy."), _c('br'), _c('br'), _vm._v(" “The standard of courage and intellect and kindness and heart.” —Gloria Steinem\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Agate Publishing, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0